import {
   CORE_LOAD_ROOMINFO_REQUEST,
   CORE_LOAD_ROOMINFO_SUCCESS,
   // CORE_LOAD_ROOMINFO_FAILURE
} from '../types'
const initialStateObj = {}
// requestState = 'request'
// , initialState = []
// , initialStateObj = {}
export default {
   room: (state = initialStateObj, action) => {
      switch (action.type) {
         case CORE_LOAD_ROOMINFO_REQUEST:
            return state
         case CORE_LOAD_ROOMINFO_SUCCESS:
            let result = {}
            if (action && action.payload && typeof action.payload === 'object') {
               result = action.payload
            }
            return result
         default:
            return state
      }
   },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerRoom.js